import React, { useState } from 'react'
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import { upload_document } from "./CompanyNameChanges";
import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import ReusableNewCompany from "../common/ReusableNewCompany";
import BusinessSearchNDetails from '../../../../../components/common/forms/BusinessSearchNDetails';
import api, { url } from '../../../../../api/api';
import { toast } from 'react-toastify';
import NewFormPayment from '../../../../../components/common/forms/NewFormPayment';



const OldCmpNameChange = () => {
  const [cmpId, setCmpId] = useState(null);
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [uploadProof, setUploadProof] = useState('')

  const handleClick = (data) => {
    // data.share_holders = shareHolders
    if (cmpId === null) {
      alert("First search company")
      return
    }
    data.documents = docsOutput
    data.company = cmpId
    data.amendment_type = "name_change";
    console.log(data)

    const user = JSON.parse(localStorage.getItem("user"))


    api.post('services/company/amendments/', data)
      .then((response) => {
        toast.success("Data Registered Successfully")


        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"

        // };

        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });

      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong")
      });

  }

  let data = [];
  upload_document.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return ''
  });




  return (
    <form>

      <BusinessSearchNDetails setCmpId={setCmpId} />

      {/* <ReusableNewCompany register={register} name={true} /> */}

      <div className="flex items-center border-x-2  border-b-2 border-primary-blue flex-col md:flex-row w-full">
        <div className="border-primary-blue flex items-center  w-full text-primary-red md:border-r    text-base font-bold sm:text-lg">
          <label>
            अब परिवर्तन गर्ने कम्पनीको नाम :
          </label>
        </div>

        <div className="border-primary-blue flex items-center border-t md:border-t-0 text-primary-red md:border-r w-full  text-base font-bold sm:text-lg">
          <label>नेपालीमा : </label>
          <input className="outline-none pl-3 text-primary-blue"
            {...register("new_company_name_nep", { required: false })}
          />
        </div>
        <div className="border-primary-blue flex items-center border-t md:border-t-0 text-primary-red border  w-full  text-base font-bold sm:text-lg">
          <p>English मा : </p>
          <input className="outline-none pl-3  text-primary-blue"
            {...register("new_company_name", { required: false })}
          />
        </div>
      </div>

      <div className="border-x-2 border-b-2 border-t-0 bg-pink-100 border-primary-blue ">
        <p className="text-primary-blue font-Laila  mt-0 text-lg font-semibold leading-10 text-center">
          शेयर सदस्यहरुको संख्याको आधारमा कम्पनीको नाम परिवर्तन सम्बन्धि काम
          गर्दा तपाईको जम्मा लाग्ने रकम <span className='text-red-400'>रु.२०,०००।– </span> मात्र ।
        </p>
      </div>

      {/* upload documents open */}
      <div className="text-primary-blue font-Calistoga text-lg underline my-4">
        2. Upload Document
        <span className="text-primary-blue font-Laila underline">  (शेयर लगत निकाल्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload गर्नुहोस ।)
        </span>
      </div>


      {/* <FormBranch /> */}
      <Documents
        documents_data={upload_document}
        initialState={data}
        setDocument={setDocsOutput}
      />
      <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
        3. Working Branch
        <span className="text-primary-blue font-Laila underline mx-2 ">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>

      <FormBranch register={register} name={'working_branch'} />
      <FormButtom />
      
      <NewFormPayment
        handleSubmit={handleSubmit}
        handleClick={handleClick}
        setUploadProof={setUploadProof}
      />
    </form>
  )
}

export default OldCmpNameChange